import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StiiraError } from '@core/models';
import { NewSchedulePost } from '@core/models/work-schedules/work-schedules.model';
import { ErrorService, LayoutService } from '@core/services';
import { WorkSchedulesService } from '@core/services/work-schedules.service';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { indicate, keepDialogOpen } from '@shared/helpers';
import { Observable, Subject } from 'rxjs';

@Component({
    selector: 'app-add-new-schedule',
    templateUrl: './add-new-schedule.component.html',
    styleUrl: './add-new-schedule.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddNewScheduleComponent implements OnInit{
  static readonly componentName = 'AddNewScheduleComponent';
  
  public form: UntypedFormGroup;

  public position = position;
  public onDragEnded = onDragEnded;

  isSubmitting$: Subject<boolean>;
  public isMobile$: Observable<boolean>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { 
      sysText: any,
      duplicateName: string,
      sourceId: number 
    },
    private service: WorkSchedulesService,
    private errorService: ErrorService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddNewScheduleComponent>,
    private layoutService: LayoutService
  ) {
    this.isSubmitting$ = new Subject();
    this.form = this.fb.group({
      scheduleName: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.isMobile$ = this.layoutService.isMobile$();
    if(this.data.duplicateName) {
      this.form.controls.scheduleName.patchValue(this.data.duplicateName + ' (' + this.data.sysText.copy + ')')
    }
  }

  public onSubmit() {
    let newSchedulePost: NewSchedulePost = {
      scheduleName: this.form.controls.scheduleName.value,
      sourceId: this.data.sourceId ?? null
    }
    this.service.postNewSchedule(newSchedulePost)
      .pipe(
        indicate(this.isSubmitting$),
        keepDialogOpen(this.dialogRef)
      )
      .subscribe((res) => {
        this.dialogRef.close(res);
      }, (err: StiiraError) => this.errorService.setFormModelStateErrors(this.form, err.modelStateErrors));
  }
}
